import Chargebee from "../../../../contents/docs/cdp/sources/_snippets/source-chargebee.mdx";
import * as React from 'react';
export default {
  Chargebee,
  React
};